module.exports = __webpack_public_path__ + "media/35.1a687074.mp3";